import Image from "next/image";
import Link from "next/link";
import { AnalyticsPreferencesButton } from "./analytics-consent";
import styles from "./site-chrome.module.css";

const PUBLIC_LINKS = [
  ["/goal-tracking", "Goals"],
  ["/accountability-groups", "Groups"],
  ["/how-it-works", "How it works"],
  ["/guides", "Guides"],
] as const;

/** One header for every public page; `dark` sits on the homepage hero. */
export function SiteHeader({ variant = "light" }: { variant?: "light" | "dark" }) {
  return (
    <header className={`${styles.header} ${variant === "dark" ? styles.dark : ""}`}>
      <Link href="/" className={styles.brand} aria-label="Kaizen home">
        <Image src="/brand-mark.png" alt="" width={32} height={32} className={styles.mark} priority />
        <span>KAIZEN</span>
      </Link>
      <nav aria-label="Public navigation">
        {PUBLIC_LINKS.map(([href, label]) => <Link key={href} href={href}>{label}</Link>)}
      </nav>
      <Link href="/login" className={styles.signIn}>Sign in</Link>
    </header>
  );
}

export function SiteFooter() {
  return (
    <footer className={styles.footer}>
      <div>
        <Link href="/" className={styles.brand}>
          <Image src="/brand-mark.png" alt="" width={28} height={28} className={styles.mark} />
          <span>KAIZEN</span>
        </Link>
        <p>Small steps. A visible record.</p>
      </div>
      <nav aria-label="Footer navigation">
        <Link href="/about">About</Link>
        <Link href="/contact">Contact</Link>
        <Link href="/guides">Guides</Link>
        <Link href="/privacy">Privacy</Link>
        <Link href="/terms">Terms</Link>
        <AnalyticsPreferencesButton />
      </nav>
      <span>Nairobi, Kenya · © {new Date().getFullYear()} Kaizen</span>
    </footer>
  );
}

export function SkipLink() {
  return <a href="#main-content" className={styles.skip}>Skip to content</a>;
}
